module.exports = __webpack_public_path__ + "static/img/bg-id.4dc7a3e7.png";